"use strict";
/**
 * @module Serialisers
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../io/codec");
/**
 * A Serialiser for Boolean values
 */
var BooleanSerialiserClass = /** @class */ (function () {
    function BooleanSerialiserClass() {
    }
    /**
     * @inheritdoc
     */
    BooleanSerialiserClass.prototype.read = function (bis) {
        return Codec.readBoolean(bis);
    };
    /**
     * @inheritdoc
     */
    BooleanSerialiserClass.prototype.write = function (bos, val) {
        Codec.writeBoolean(bos, val);
    };
    return BooleanSerialiserClass;
}());
exports.BooleanSerialiserClass = BooleanSerialiserClass;
/**
 * The {@link BooleanSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.BooleanSerialiser = new BooleanSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/serialisers/boolean-serialiser.js
// module id = 502
// module chunks = 1